

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductModelService } from '../../../services/product-model.service';

@Component({
  selector: 'app-view-product-models',
  templateUrl: './view-product-models.component.html',
  styleUrls: ['./view-product-models.component.css'],
  providers:[ProductModelService]
})
export class ViewProductModelsComponent implements OnInit {
  id: number = undefined;
  private sub: any;
  productModel: any = {
    laptops: false,
    consoles: false,
    products: false,
    mobiles: false
  };
  constructor(private productModelService:ProductModelService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      if (params['id'] !== undefined){
        this.id = params['id'];
        this.getProductModel();
      }
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getProductModel(){
    this.productModelService.get(this.id).subscribe((productModel) => {
      this.productModel = productModel;
    });
  }
  

  saveProductModel(){
    this.parseProductsType();
    if (this.productModel.id == undefined){
      this.productModelService.create(this.returnProductModelProperties(this.productModel))
      .subscribe((productModel) => {
        this.productModelService.get(productModel.id).subscribe((productModel) => {
          this.productModel = productModel;
          this.router.navigate(['/configuration/productmodels']);
        });
      });
    }else{
      this.productModelService.update(this.returnProductModelProperties(this.productModel))
      .subscribe((productModel) => {
        this.productModel = productModel;
      });
    }
  }

  returnProductModelProperties(productModel){
    var properties = {
      name: productModel.name,
      product_types: productModel.product_types
    }
    if (productModel.id){
      properties['id'] = productModel.id;
    }
    return properties;
  }

  parseProductsType(){
    this.productModel.product_types = "";
    if(this.productModel.mobiles === true){
      this.productModel.product_types += "1,";
    }
    if(this.productModel.consoles === true){
      this.productModel.product_types += "2,";
    }
    if(this.productModel.products === true){
      this.productModel.product_types += "3,";
    }
    if(this.productModel.laptops === true){
      this.productModel.product_types += "4,";
    }
    this.productModel.product_types = this.productModel.product_types.substring(0,this.productModel.product_types.length - 1);
  }

}



// WEBPACK FOOTER //
// ./src/app/configuration/components/product-models/view-product-models/view-product-models.component.ts